import {
  TextArea as KendoTextArea,
  TextAreaChangeEvent,
  TextAreaProps,
} from '@progress/kendo-react-inputs';
import _ from 'lodash';
import { ValidationError } from '../../apps/benefit/models/Errors';
import ErrorViewer from './ErrorViewer';

interface ITextAreaProps {
  label?: string;
  controlClassName?: string;
  mandatory?: boolean;
  helper?: string;
  errors?: ValidationError[];
  clearErrors?: () => void;
}

const TextArea = (props: ITextAreaProps & TextAreaProps) => {
  const {
    label,
    controlClassName,
    mandatory,
    helper,
    id,
    errors,
    clearErrors,
    onChange,
  } = props;
  const internalOnChange = (e: TextAreaChangeEvent) => {
    if (errors?.length) {
      clearErrors?.();
    }
    onChange?.(e);
  };

  const classNames = `control-group ${controlClassName ?? ''} ${
    errors ? 'control-error' : ''
  }`.trim();

  return (
    <div className={classNames}>
      <div className="control-content">
        {!!label && (
          <label htmlFor={id}>
            {label}
            {mandatory && <sup>*</sup>}
          </label>
        )}
        <KendoTextArea
          {..._.omit(props, 'mandatory', 'clearErrors')}
          onChange={internalOnChange}
        />
      </div>
      {!!helper && <div className="control-info">{helper}</div>}
      <ErrorViewer errors={errors} />
    </div>
  );
};

export default TextArea;
